import React from 'react';
import PropTypes from 'prop-types';
import { Popconfirm } from 'antd';
import './RDPopup.scss';

const RDPopup = ({
  title,
  confirmText,
  cancelText,
  onConfirm,
  children,
  popDisabled,
  cancelButtonStyle,
  placement,
  popStyle,
}) => (
  <Popconfirm
    title={title}
    okText={confirmText}
    cancelText={cancelText}
    onConfirm={onConfirm}
    disabled={popDisabled}
    cancelButtonProps={cancelButtonStyle}
    placement={placement}
    style={popStyle}
  >
    {children}
  </Popconfirm>
);

RDPopup.defaultProps = {
  onConfirm: () => {},
  title: '',
  confirmText: '',
  cancelText: '',
  popDisabled: false,
  cancelButtonStyle: {},
  placement: 'top',
  popStyle: {},
};

RDPopup.propTypes = {
  /** Popup title */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** React Node */
  children: PropTypes.element.isRequired,
  /** Specify a function that will be called when a user clicks the confirm button */
  onConfirm: PropTypes.func,
  /** Text of the confirm button */
  confirmText: PropTypes.string,
  /** Text of the cancel button */
  cancelText: PropTypes.string,
  /** The cancel button style. */
  cancelButtonStyle: PropTypes.shape({}),
  /** Whether the popup is disabled or not */
  popDisabled: PropTypes.bool,
  /** Can be set to - topLeft | top | topRight | leftTop | left | leftBottom | rightTop | right | rightBottom | bottomLeft | bottom | bottomRight */
  placement: PropTypes.string,
  /** Popup styles */
  popStyle: PropTypes.shape({}),
};

export default RDPopup;
